import { render } from "./Rechnungsadresse.vue?vue&type=template&id=55a885f0"
import script from "./Rechnungsadresse.vue?vue&type=script&lang=js"
export * from "./Rechnungsadresse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__